const cache = new Map();
const pending = new Map();

export function getMemoryCache(key, ttlMs) {
  const entry = cache.get(key);
  if (!entry || Date.now() - entry.cachedAt >= ttlMs) {
    cache.delete(key);
    return undefined;
  }
  return entry.value;
}

export function setMemoryCache(key, value) {
  cache.set(key, { value, cachedAt: Date.now() });
  return value;
}

export function invalidateMemoryCache(key) {
  if (key) cache.delete(key);
  else cache.clear();
}

export async function getOrFetchMemoryCache(key, fetcher, ttlMs) {
  const cached = getMemoryCache(key, ttlMs);
  if (cached !== undefined) return cached;

  if (pending.has(key)) return pending.get(key);

  const request = Promise.resolve()
    .then(fetcher)
    .then(value => setMemoryCache(key, value))
    .finally(() => pending.delete(key));

  pending.set(key, request);
  return request;
}